import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { appModeAtom } from "@/state/app.state";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai";
import { BarChart3, Calendar, Map, Table } from "lucide-react";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function Nav() {
  const mode = useAtomValue(appModeAtom);
  const location = useLocation();
  const navigate = useNavigate();

  const prefix = mode === "demo" ? "/demo" : "/app";

  const tab = useMemo<"charts" | "table" | "calendar" | "map">(() => {
    if (location.pathname.includes("/table")) return "table";
    if (location.pathname.includes("/calendar")) return "calendar";
    if (location.pathname.includes("/map")) return "map";
    return "charts";
  }, [location.pathname]);

  return (
    <Tabs
      value={tab}
      onValueChange={(next) => {
        if (next === "charts") navigate(`${prefix}/charts`);
        if (next === "table") navigate(`${prefix}/table`);
        if (next === "calendar") navigate(`${prefix}/calendar`);
        if (next === "map") navigate(`${prefix}/map`);
      }}
    >
      <TabsList className="inline-flex">
        <TabsTrigger value="charts" className="flex items-center gap-2">
          <BarChart3 className="h-4 w-4" />
          <span className="hidden sm:inline">
            <Trans>Charts</Trans>
          </span>
        </TabsTrigger>

        <TabsTrigger value="table" className="flex items-center gap-2">
          <Table className="h-4 w-4" />
          <span className="hidden sm:inline">
            <Trans>Table</Trans>
          </span>
        </TabsTrigger>

        <TabsTrigger value="calendar" className="flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          <span className="hidden sm:inline">
            <Trans>Calendar</Trans>
          </span>
        </TabsTrigger>

        <TabsTrigger value="map" className="flex items-center gap-2">
          <Map className="h-4 w-4" />
          <span className="hidden sm:inline">
            <Trans>Map</Trans>
          </span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
